export interface CampusWorkspace {
  title: string;
  description: string;
  image: string;
}

export interface City {
  city?: string;
  state?: string;
}

export interface Campus extends City {
  id?: number;
  name?: string;
  description?: string;
  address?: string;
  neighborhood?: string;
  photos?: string[];
  workspaces?: CampusWorkspace[];
  amenities?: string[];
  isAvailable?: boolean;
}

export interface LocationState {
  city?: City;
  campus?: Campus;
  availableCities?: string[];
  availableCampuses?: Campus[];
  campusDetails?: Campus;
}

const state: LocationState = {
  city: undefined,
  campus: undefined,
  availableCities: [],
  availableCampuses: [],
  campusDetails: undefined,
};

export default state;
